import { Fragment, useCallback, useMemo } from "react";
import { Dropdown, Form } from "react-bootstrap";
import { useFormikContext } from "formik";
import Container from "../container";
import Select from "../selects/selectWithSearch";
import { Input } from "./components";
import { useGetMemTable } from "../../hooks/useMemoryDB";
import { catalogOptions } from "./catalogs";
import styles from "./styles.module.scss";

/**
 * From Catalog: the pipelines of the loader run together on the catalog documents whose ids
 * are in a field of the document (eg. the window of the last videos of a session), instead of
 * on the document itself (ares-content-loader `pipelines.fromCatalog`).
 */
export default function FromCatalog() {
  const { values, setFieldValue } = useFormikContext();
  const loaders = useGetMemTable("loaders");
  const fromCatalog = values.pipelines?.fromCatalog;
  const active = fromCatalog?.active ?? false;

  const options = useMemo(
    () => catalogOptions(loaders, values.index),
    [loaders, values.index]
  );
  const items = useMemo(
    () =>
      options.map((index) => (
        <Dropdown.Item eventKey={index} key={`catalog-${index}`}>
          {index}
        </Dropdown.Item>
      )),
    [options]
  );

  const set = useCallback(
    (key, value) => setFieldValue(`pipelines.fromCatalog.${key}`, value),
    [setFieldValue]
  );

  return (
    <Container
      title="From Catalog"
      help="loader-pipelines"
      headerOnlyOnFolded={false}
      folded={true}
      foldable={active}
      extra={
        <Form.Check
          type="switch"
          value="true"
          checked={active}
          onChange={(e) => set("active", e.target.checked)}
          id="activate-from-catalog"
          name="activate-from-catalog"
          label="Active"
          title="The pipelines run on the catalog documents whose ids are in the IDs Field of the document (an array, repetitions weigh in the synthesizer, or a comma separated string), not on the document itself. Fingerprint, tags, segments and synthesis are injected in the document; Egress does not apply."
          className={styles.switch}
        />
      }
    >
      {active && (
        <div className={styles.settingsHeader}>
          <span className={styles.label}>IDs Field</span>
          <Input
            data={fromCatalog?.idsField}
            placeholder="window"
            onChange={(v) => set("idsField", v)}
          />
          <span className={styles.label}>Catalog</span>
          <Select
            name="select-from-catalog"
            value={fromCatalog?.catalog || "Select a catalog"}
            canFilter={items.length > 5}
            errored={!fromCatalog?.catalog}
            onSelect={(index) => set("catalog", index)}
            className={styles.labelSelect}
          >
            <Fragment key="select-from-catalog-values">{items}</Fragment>
          </Select>
        </div>
      )}
    </Container>
  );
}
